import * as React from 'react';
import { PageContext, PageProvider } from '@narvar/nth-hook-context-page';
import { ApolloProvider } from '@apollo/react-hooks';
import { GrowthBookProvider } from '@growthbook/growthbook-react';
import CustomComponentContext from './CustomComponentContext';
import useApolloClient from '../hooks/useApolloClient';
import useGrowthBookClient from '../hooks/useGrowthBookClient';
import {
  TitanAnalyticsOptions,
  TitanAnalyticsProvider,
} from '../hooks/useTitanAnalytics';

interface ProvidersProps {
  children?: React.ReactNode;
}

const Providers: React.FunctionComponent<ProvidersProps> = ({ children }) => {
  const { state } = React.useContext(CustomComponentContext);

  const { LOMA_URL, GROWTHBOOK_CLIENT_KEY, TITAN_URL } = process.env;

  if (!LOMA_URL) throw new Error('Expected LOMA_URL to be defined');
  if (!GROWTHBOOK_CLIENT_KEY)
    throw new Error('Expected GROWTHBOOK_CLIENT_KEY to be defined');
  if (!TITAN_URL) throw new Error('Expected TITAN_URL to be defined.');

  const apolloClient = useApolloClient();
  const growthbook = useGrowthBookClient({
    dataPlaneUrl: TITAN_URL,
    sourceWriteKey: state.pageContext.retailerMoniker,
  });

  if (!apolloClient) return null;
  if (!state?.pageContext) return null;

  const titanAnalyticsOptions: TitanAnalyticsOptions = {
    sourceWriteKey: state.pageContext.retailerMoniker,
    dataPlaneUrl: TITAN_URL,
  };

  return (
    <PageProvider initialState={state.pageContext as PageContext}>
      <ApolloProvider client={apolloClient}>
        <TitanAnalyticsProvider value={titanAnalyticsOptions}>
          <GrowthBookProvider growthbook={growthbook}>
            {children}
          </GrowthBookProvider>
        </TitanAnalyticsProvider>
      </ApolloProvider>
    </PageProvider>
  );
};

export default Providers;
